export const TOGGLE_MAP = 'TOGGLE_MAP';

export const GO_TO_PATH = 'GO_TO_PATH';
export const GO_TO_TOURISTS = 'GO_TO_TOURISTS';
export const GO_TO_TOURISTS_HOTEL_CHECKOUT = 'GO_TO_TOURISTS_HOTEL_CHECKOUT';
export const GO_TO_PAY = 'GO_TO_PAY';
export const GO_TO_CLIENT = 'GO_TO_CLIENT';
export const GO_TO_CLIENT_DATA = 'GO_TO_CLIENT_DATA';
export const GO_TO_HOTEL = 'GO_TO_HOTEL';
export const GO_TO_FLIGHT = 'GO_TO_FLIGHT';
export const SCROLL_TO_TOURISTS = 'SCROLL_TO_TOURISTS';
export const SCROLL_TO_TOP = 'SCROLL_TO_TOP';
export const SCROLL_TO_BOOKING = 'SCROLL_TO_BOOKING';
export const SCROLL_TO_LOG_IN = 'SCROLL_TO_LOG_IN';
export const SCROLL_TO_PAYMENT_BLOCK = 'SCROLL_TO_PAYMENT_BLOCK';
export const ROUTE_TRANSITION_START = 'ROUTE_TRANSITION_START';
export const ROUTE_TRANSITION_END = 'ROUTE_TRANSITION_END';
export const EXPAND_TOURIST_FORM = 'EXPAND_TOURIST_FORM';
export const SET_TOPBAR_INDEX = 'SET_TOPBAR_INDEX';
export const TOGGLE_TOPBAR = 'TOGGLE_TOPBAR';
export const SCROLL_POSITION = 'SCROLL_POSITION';
export const RESET_SCROLL_POSITION = 'RESET_SCROLL_POSITION';
export const TOGGLE_FILTERS_PANEL = 'TOGGLE_FILTERS_PANEL';
export const SET_FLIGHTS_PROGRESSBAR_IS_STICKY =
  'SET_FLIGHTS_PROGRESSBAR_IS_STICKY';
export const SET_SHOW_SUMMARY = 'SET_SHOW_SUMMARY';
export const SET_INITIAL_OPENED_FIELD = 'SET_INITIAL_OPENED_FIELD';

// time in ms to redirect to order page
export const REDIRECT_TO_ORDER_DELAY = 3000;
